module.exports = __webpack_public_path__ + "img/people_tm.b5fd14d4.png";